import { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useCart } from '@kidslabs/module-quote';
import { checkoutStoreAPI } from '@kidslabs/module-checkout';
import { useMarketingRemoveCode } from '../../../api';
import { type MarketingCodeType } from '../../../types/marketing.graphql';

export const useRemoveCode = () => {
    const { cartId } = useCart();
    const { t } = useTranslation('flash-sale');
    const [errorMessage, setErrorMessage] = useState<string | undefined>();

    const { removeCode: removeCodeMutation, loading: removeLoading } = useMarketingRemoveCode();

    const removeCode = useCallback(
        async (codeId: string, type: MarketingCodeType) => {
            setErrorMessage(undefined);
            if (!cartId) {
                return;
            }
            const result = await removeCodeMutation({
                variables: { code_id: codeId, type, cart_id: cartId },
            });

            const response = result?.data?.marketingRemoveCode;
            if (!response?.success) {
                const message = response?.error_message || t('text_coupon_remove_failed');
                setErrorMessage(message);
                throw new Error(message);
            }

            // Signal hooks watching discountVersion to refetch their data
            checkoutStoreAPI.actions.incrementDiscountVersion();
        },
        [cartId, removeCodeMutation, t]
    );

    return {
        removeCode,
        removeLoading,
        errorMessage,
        setErrorMessage,
    };
};
